module.exports = __webpack_public_path__ + "img/Invasion-GBM_10X_WTA.c7481dbc.png";